import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container py-5"
}
const _hoisted_2 = { class: "row mb-4" }
const _hoisted_3 = { class: "col-md-3 text-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "col-md-9" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Qualification :", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "Nationalité :", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "Email :", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", null, "Téléphone :", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "Années d'expérience :", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h4", null, "Biographie", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h4", null, "Matières enseignées", -1)
const _hoisted_17 = { class: "matiere-list" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h4", null, "Activités", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.prof)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.prof.user?.urlImage)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.getImageUrl(_ctx.prof.user.urlImage),
                  alt: "Photo disciple",
                  class: "detail-photo"
                }, null, 8, _hoisted_4))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _ctx.defaultPhoto,
                  alt: "Photo par défaut",
                  class: "detail-photo"
                }, null, 8, _hoisted_5))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.prof.nom) + " " + _toDisplayString(_ctx.prof.prenom), 1),
            (_ctx.prof.qualification)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(_ctx.prof.qualification.libelle), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", null, [
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.prof.nationalite), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_10,
              _createTextVNode(" " + _toDisplayString(_ctx.prof.email), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_11,
              _createTextVNode(" " + _toDisplayString(_ctx.prof.telProfesseur1), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_12,
              _createTextVNode(" " + _toDisplayString(_ctx.prof.anneeExperience), 1)
            ])
          ])
        ]),
        _hoisted_13,
        _hoisted_14,
        _createElementVNode("p", null, _toDisplayString(_ctx.prof.biographie), 1),
        _hoisted_15,
        _hoisted_16,
        _createElementVNode("ul", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prof.matieres, (matiere) => {
            return (_openBlock(), _createElementBlock("li", {
              key: matiere.id
            }, _toDisplayString(matiere.libelle), 1))
          }), 128))
        ]),
        (_ctx.prof.activites?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _hoisted_19,
              _hoisted_20,
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prof.activites, (act) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: act.id
                  }, _toDisplayString(act.libelle), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}